/** The backend request takes numeric expression binding IDs; chart selection uses stable series IDs. */
const BINDING_ID_PATTERN = /^expression:([1-9]\d*)$/;

export function getBindingIds(selectedSeriesIds: string[]): number[] {
  return selectedSeriesIds.flatMap((seriesId) => {
    const match = BINDING_ID_PATTERN.exec(seriesId);

    if (!match) {
      return [];
    }

    const bindingId = Number(match[1]);
    return Number.isSafeInteger(bindingId) ? [bindingId] : [];
  });
}
